import { Routes, Route} from 'react-router-dom';

// Importing Pages
import Home from './Pages/Home';
import Appointments from './Pages/Appointments/Appointments';
import Services from './Pages/Services/Services'
import AboutUs from './Pages/AboutUs'
import Contact from './Pages/Contact'
import CheckAppointment from 'Pages/Appointments/CheckAppointment'
import Quote from 'Pages/Quote'

// Importing Components
import Navbar from './Components/Navbar';
import Footer from './Components/Footer'

// Errors
import Error404 from './Pages/errors/error404';


// Importing Pages for appointments flow
import AppointmentsLayout from "./Layouts/AppointmentsLayout";
import CarDetails from "./Pages/Appointments/CarDetails";
import ServiceDetails from "./Pages/Appointments/ServiceDetails";
import SelectDate from "./Pages/Appointments/SelectDate";
import ContactInfo from './Pages/Appointments/ContactInfo'
import ReviewAppointment from './Pages/Appointments/ReviewAppointment'
import BookingConfirmation from 'Pages/Appointments/BookingConfirmation';

const App = () => {
  return (
    <div className="min-h-screen flex flex-col">
    <Navbar />
    <main className="flex-1">
    <Routes>
      <Route path='/' element= {<Home />} />
      <Route path='/oldappointments' element= {<Appointments />} />
      <Route path='/services' element= {<Services />} />
      <Route path='/about' element= {<AboutUs />} />
      <Route path='/contact' element= {<Contact />} />
      <Route path='*' element= {<Error404 />} />
      <Route path="/check" element={<CheckAppointment />} />
      <Route path="quote" element={<Quote />} />

      {/* Appointments Flow Routes */}
      <Route path="/appointments" element={<AppointmentsLayout />}>
      <Route index element={<CarDetails />} />
      <Route path="service" element={<ServiceDetails />} />
      <Route path="contactInfo" element={<ContactInfo />} />
      <Route path="date" element={<SelectDate />} />
      <Route path="reviewAppointment" element={<ReviewAppointment />} />
      <Route path="bookingConfirmation" element={<BookingConfirmation />} />
      
      </Route>
    </Routes>
    </main>
    <Footer />

      
    
    </div>
  )
}

export default App;